import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'

type Profile = {
  role: 'USER' | 'ADMIN'
  must_change_password: boolean
}

type RequireAdminProps = {
  children: JSX.Element
}

const RequireAdmin: React.FC<RequireAdminProps> = ({ children }) => {
  const [checking, setChecking] = useState(true)
  const [authorized, setAuthorized] = useState(false)

  const location = useLocation()

  useEffect(() => {
    const check = async () => {
      setChecking(true)

      const { data: { user }, error: userError } = await supabase.auth.getUser()

      if (userError || !user) {
        setAuthorized(false)
        setChecking(false)
        return
      }
      console.log("Checking admin role for user:", user.id);

      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', user.id)
        .single<Profile>()

      if (profileError || !profile || profile.role !== 'ADMIN') {
        setAuthorized(false)
        setChecking(false)
        return
      }

      setAuthorized(true)
      setChecking(false)
    }

    void check()
  }, [])

  if (checking) {
    return (
      <div style={{ padding: '1.5rem' }}>
        <p>Vérification des droits d’accès…</p>
      </div>
    )
  }

  if (!authorized) {
    // redirection vers la page de login admin, avec la route d'origine
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  return children
}

export default RequireAdmin
